import { render, staticRenderFns } from "./HRAssApprove.vue?vue&type=template&id=652ab695&scoped=true"
import script from "./HRAssApprove.vue?vue&type=script&lang=js"
export * from "./HRAssApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ab695",
  null
  
)

export default component.exports